export default "__VITE_ASSET__EzC0kKJO__"